import { mutations } from './mutations';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';

import { mutations as devMutations } from '../../../_dev/mutations';
import { state as devState } from '../../../_dev/state';
import { getters as devGetters } from '../../../_dev/getters';
import { actions as devActions } from '../../../_dev/actions';


const store = {
    state: { ...state, ...devState },

    mutations: { ...mutations, ...devMutations },

    actions: { ...actions, ...devActions },

    getters: { ...getters, ...devGetters }

};

export default store;
